import React from 'react';
import { useInView } from 'react-intersection-observer';

import { ReactComponent as Arrow } from '../../images/icons/fs-lc-arrow.svg';
import PageSection from '../PageSections/PageSection';
import ContentfulImage from './ContentfulImage';
import * as styles from './MasonryGrid.module.scss';
import RichTextConverter from './RichText/RichTextConverter';
import SmartLink from './SmartLink';

const Card = ({ card, className }) => {
  const { ref: containerRef, inView: isVisible } = useInView({
    threshold: 0.25,
    triggerOnce: true,
  });
  return (
    <div
      ref={containerRef}
      className={[className, isVisible ? styles.visible : styles.hidden].join(' ')}
      data-analytics-component={'masonry-card'}
      data-analytics-id={card.title}
    >
      <div className={styles.copy}>
        <div className={styles.title}>{card.title}</div>
        {card.linkUrl ? (
          <SmartLink className={styles.cta} to={card.linkUrl}>
            {card.linkLabel} <Arrow className={styles.arrow} />
          </SmartLink>
        ) : (
          <RichTextConverter copy={card.body} className={styles.cta} />
        )}
      </div>
      <ContentfulImage className={styles.image} imageFragment={card.image} />
    </div>
  );
};

export default function MasonryGrid({ title, content, backgroundColor }) {
  const isEven = content.length % 2 === 0;
  const columns = isEven ? content : content.slice(1);

  const backgroundColors = {
    'Evergreen Deep': styles.evergreenDeep,
  };

  return (
    <PageSection slim data-analytics-section={'masonry-grid'} className={backgroundColors[backgroundColor]}>
      {title && <h2 className={styles.title}>{title}</h2>}
      {!isEven && <Card card={content.slice(0, 1)[0]} className={[styles.card, styles.first].join(' ')} />}
      <div className={styles.masonryGrid}>
        {columns?.map((card, i) => (
          <Card key={i} card={card} className={styles.card} />
        ))}
      </div>
    </PageSection>
  );
}
